
    import '/Users/zcy/Desktop/pc-virtual-table-front-release-3.0.1/pages/index.md?watch=parent';
    export const toc = [];
export const frontmatter = {"title":"Pages","toc":"menu","filename":"pages/index.md","lastUpdated":1773900960000,"hero":{"title":"虚拟表格表单","description":"react-VFormTable是基于 rc-table + 自定义表格表单系统 + 自定义UI库 编写的 React UI 组件库，用于快速编写表格表单业务，解决大数据渲染瓶颈。"}};